import React from "react";

const PincodeStatus = ({ status, message }) => {
  if (status === "idle") return null;

  if (status === "checking") {
    return (
      <div className="mt-3 flex items-center gap-2.5 rounded-xl border border-blue-100 bg-blue-50 px-4 py-3">
        <svg
          className="h-4 w-4 animate-spin shrink-0 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8z"
          />
        </svg>
        <p className="text-sm font-semibold text-blue-700">
          Checking delivery availability…
        </p>
      </div>
    );
  }

  if (status === "serviceable") {
    return (
      <div className="mt-3 flex items-start gap-3 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3">
        <div className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-500">
          <svg
            className="h-3 w-3 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={3}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <div>
          <p className="text-sm font-bold text-emerald-700">
            Delivery available for your location! 🎉
          </p>
          <p className="mt-0.5 text-xs text-emerald-600">{message}</p>
        </div>
      </div>
    );
  }

  if (status === "not_serviceable") {
    return (
      <div className="mt-3 overflow-hidden rounded-xl border border-red-200 bg-red-50">
        <div className="flex items-start gap-3 px-4 py-3">
          <div className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-500">
            <svg
              className="h-3 w-3 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={3}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
          <div className="flex-1">
            <p className="text-sm font-bold text-red-700">
              Delivery not available for this pincode
            </p>
            <p className="mt-0.5 text-xs text-red-500">
              {message || "We don't deliver to this area yet."}
            </p>
          </div>
        </div>
        <div className="border-t border-red-100 bg-red-50/80 px-4 py-2.5">
          <p className="text-xs font-semibold text-red-600">
            💡 Try a nearby pincode or{" "}
            <a href="/contact" className="underline hover:text-red-700">
              contact us
            </a>{" "}
            to request delivery to your area.
          </p>
        </div>
      </div>
    );
  }

  // error
  return (
    <div className="mt-3 flex items-center gap-2.5 rounded-xl border border-red-200 bg-red-50 px-4 py-3">
      <svg
        className="h-4 w-4 shrink-0 text-red-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
        />
      </svg>
      <div className="flex-1">
        <p className="text-sm font-semibold text-red-700">Unable to verify pincode</p>
        <p className="mt-0.5 text-xs text-red-600">{message || "Please check your internet connection and try again."}</p>
      </div>
    </div>
  );
};

export default PincodeStatus;
